import axios from "axios"

/**
 * API-Client des Terminals. Frei aufrufbar bis zur Chipleser-Ansicht; danach trägt jede
 * Anfrage die Bediener-Sitzung (nur im Speicher, endet nach Inaktivität). Kein Authentik,
 * keine Gerät-Registrierung.
 */
export const terminalApi = axios.create({ baseURL: `${import.meta.env.BASE_URL}api/v1/terminal` })

let sitzung: string | null = null

export function setzeSitzung(token: string | null): void {
  sitzung = token
}

terminalApi.interceptors.request.use((config) => {
  if (sitzung) config.headers["X-Sitzung"] = sitzung
  return config
})

export interface Jetzt {
  datum: string
  zeitfenster: string
  schicht: "Früh" | "Spät" | "Nacht"
  uhrzeit: string
}

export interface TerminalStatus {
  anlage: string
  jetzt: Jetzt
  sitzung_sekunden: number
}

export type Werte = Record<string, string | number | boolean | null | undefined>

export interface Vorauswahl {
  jetzt: Jetzt
  zuletzt: (Werte & { datum: string; zeitfenster: string | null }) | null
  mischung_vorschlag: string | null
  auswahl: { nc_typ: string[]; gebinde: string[]; medium: string[] }
  schicht_fenster: Array<{ zeitfenster: string; erfasst: boolean; faellig: boolean }>
  grenzen: Record<string, [number, number]>
}

export interface ProbeAntwort extends Werte {
  id: number
  datum: string
  zeitfenster: string | null
  schicht: string | null
  durchsatz_kg_h: number | null
  pruefung: string
  quelle: string
  erfasst_von: string | null
  erfasst_um: string | null
  eigene: boolean
}

/** Antwort-Details bei Fehlern: {"detail": "…", "warnungen": [...], "chipnummer": "…"} */
export function antwortDetails(error: unknown): { status: number; detail: string; warnungen?: string[]; chipnummer?: string } {
  const r = (error as { response?: { status?: number; data?: Record<string, unknown> } })?.response
  if (!r) return { status: 0, detail: "Keine Verbindung zum Server. Bitte erneut versuchen." }
  const d = r.data ?? {}
  return {
    status: r.status ?? 0,
    detail: typeof d.detail === "string" ? d.detail : "Das hat nicht geklappt.",
    warnungen: Array.isArray(d.warnungen) ? (d.warnungen as string[]) : undefined,
    chipnummer: typeof d.chipnummer === "string" ? d.chipnummer : undefined,
  }
}
